class IntoCultureApiClientError extends Error {
  constructor(message) {
    super(message);
    this.name = "IntoCultureApiClientError";
  }
}

export default IntoCultureApiClientError;
